// Mirrors EditTwigHelper's reg_format Twig filter (thousands-separated,
// comma as decimal separator - not used here since these are always
// whole counts, but kept for parity).
export function regFormat(value) {
    return Number(value || 0).toLocaleString('nb-NO');
}
